import api from "./api";

/**
 * Add Food To Cart
 */
export const addToCart = async (foodId) => {

  console.log("===== cartApi =====");
  console.log("foodId:", foodId);

  const payload = {
    foodId,
  };

  console.log("Payload:", payload);

  const response = await api.post("/cart/add", payload);

  return response.data;
};

/**
 * Get Customer Cart
 */
export const getCart = async () => {
  const response = await api.get("/cart");

  return response.data;
};

/**
 * Increase Quantity
 */
export const increaseQuantity = async (foodId) => {
  const response = await api.patch(
    `/cart/increase/${foodId}`
  );

  return response.data;
};

/**
 * Decrease Quantity
 */
export const decreaseQuantity = async (foodId) => {
  const response = await api.patch(
    `/cart/decrease/${foodId}`
  );

  return response.data;
};

/**
 * Remove Item
 */
export const removeFromCart = async (foodId) => {
  const response = await api.delete(
    `/cart/remove/${foodId}`
  );

  return response.data;
};

/**
 * Clear Cart
 */
export const clearCart = async () => {
  const response = await api.delete("/cart/clear");

  return response.data;
};